"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layout = exports.DESK_ANIMATION_TIME = void 0;
// ------------- desktop animation time ---------------------------
exports.DESK_ANIMATION_TIME = 500; // ms
exports.layout = {
    desktopNavWidth: 311,
};
